//                                      BİSMİLLAHİRRAHMANİRRAHİM
//                                           ALLAHU  EKBER
//                                           ELHAMDÜLİLLAH

import {Turkish, English} from '../../strings/index';
import detectLanguage from '../common';
import svgOne from '../../images/hakkimda.svg'
import svgTwo from '../../images/Biiznillahgelistirici.svg'
import svgThree from '../../images/Biiznillahgelistirici2.svg'
import svgFour from '../../images/Elhamdulillahtasarim.svg'


let Language;
if(detectLanguage() == "en-US")
    Language = English;
else
    Language = Turkish;

export const homeObjOne = {
    id: Language.Navbar.LinkHelpers[0],
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: Language.InfoSection[0].topLine,
    headline: Language.InfoSection[0].headline,
    description: Language.InfoSection[0].description,
    buttonLabel: Language.InfoSection[0].buttonLabel,
    imgStart: false,
    img : svgOne,
    alt: 'hakkimda',
    dark: true,
    primary: false,
    darkText: false,
    toWhere : Language.Navbar.LinkHelpers[1]
}

export const homeObjTwo = {
    id: Language.Navbar.LinkHelpers[1],
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: Language.InfoSection[1].topLine,
    headline: Language.InfoSection[1].headline,
    description: Language.InfoSection[1].description,
    buttonLabel: Language.InfoSection[1].buttonLabel,
    imgStart: true,
    img : svgTwo,
    alt: 'gelistirici',
    dark: false,
    primary: true,
    darkText: true,
    toWhere : Language.Navbar.LinkHelpers[2]

}

export const homeObjThree = {
    id: Language.Navbar.LinkHelpers[2],
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: Language.InfoSection[2].topLine,
    headline: Language.InfoSection[2].headline,
    description: Language.InfoSection[2].description,
    buttonLabel: Language.InfoSection[2].buttonLabel,
    imgStart: false,
    img : svgThree,
    alt: 'web',
    dark: true,
    primary: false,
    darkText: false,
    toWhere : Language.Navbar.LinkHelpers[3]
}

export const homeObjFour = {
    id: Language.Navbar.LinkHelpers[3],
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: Language.InfoSection[3].topLine,
    headline: Language.InfoSection[3].headline,
    description: Language.InfoSection[3].description,
    buttonLabel: Language.InfoSection[3].buttonLabel,
    imgStart: true,
    img : svgFour,
    alt: 'hakkimda',
    dark: false,
    primary: true,
    darkText: true,
    toWhere : Language.Navbar.LinkHelpers[4],
    offset: 250
}